<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent transition="dialog-top-transition" max-width="600px">
      <v-card>
        <div class="container change-plan">
          <img
            src="img/icons_v2/ico-close@3x.png"
            width="45px"
            height="45px"
            @click="$emit('dialog-close')"
            class="icon-close"
          />
          <div class="box title">
            <h2>เปลี่ยนวันนัดใหม่</h2>
          </div>
          <div class="box plusdate">
            <span class="font-w-600">เลื่อนไปอีก :</span>
            <div class="card-plus">
              <button type="button" class="btn btn-plusdate" @click="pluseDate(1)">+ 1 วัน</button>
              <button type="button" class="btn btn-plusdate" @click="pluseDate(3)">+ 3 วัน</button>
              <button type="button" class="btn btn-plusdate" @click="pluseDate(7)">+ 7 วัน</button>
            </div>
          </div>
          <div class="assign-date">
            <span class="font-w-600">วันที่ :</span>
            <v-col class="p-0 py-3">
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="date"
                persistent
                width="600px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="toggleDate"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                    height="70"
                  >
                    <v-icon slot="append" color="gray">icon-Calendar</v-icon>
                  </v-text-field>
                </template>

                <v-date-picker v-model="toggleDate" color="red lighten-1" width="550" class="mt-4">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="saveDate(toggleDate)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <button type="button" class="btn btn-changedate" @click="submitChangeDate()">
              เปลี่ยนวันนัด
            </button>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    date: String
  },

  emits: ['change-duedate', 'dialog-close', 'submit-duedate'],

  data() {
    return {
      modal: false
    }
  },

  computed: {
    toggleDate: {
      get() {
        return this.date
      },
      set(value) {
        this.saveDate(value)
      }
    }
  },

  methods: {
    saveDate(value) {
      this.$refs.dialog.save(value)
      this.modal = false
      this.$emit('change-duedate', value)
    },

    pluseDate(value) {
      const strDate = new Date(this.date)
      strDate.setDate(strDate.getDate() + value)
      const fmDate = this.formatDate(strDate)
      this.$emit('change-duedate', fmDate)
    },

    formatDate(valueDate) {
      const rusult = new Date(valueDate - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
      return rusult
    },

    submitChangeDate() {
      this.$emit('submit-duedate')
    }
  }
}
</script>

<style lang="scss" scoped>
.container.change-plan {
  padding: 25px;
}
.box {
  border-bottom: 3px solid #eef3fa;
  &.title {
    text-align: center;
    h2 {
      padding: 20px 0px;
    }
  }
  &.plusdate {
    margin: 25px 0px;
  }
}
.card-plus {
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
  height: 110px;
}
.icon-close {
  position: absolute;
  right: 5px;
  top: 5px;
}

.assign-date {
  margin: 10px 0px;
}

// button
.btn-plusdate {
  width: 30%;
  background: #f26f21;
  color: #ffffff;
  font-weight: 600;
  margin: 0px;
}
.btn-changedate {
  width: 100%;
  background: #a50200;
  color: #ffffff;
  font-weight: 600;
  margin: 5px 0px;
  border-radius: 10px;
}

.icon-Calendar:before {
  content: '\e95d';
  color: #aeaeae;
  font-size: 35px;
}
</style>
